<template>
  <div>
    <ValidationObserver ref="observer">
      <b-row class="mt-1">
        <b-col>
          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="Organization Name"
          >
            <c-input
              inputType="text"
              :inputId="`organizationName`"
              lableText="Organization Name *"
              v-model="organization.name"
              class="mt-0"
            />
            <span class="validate-error" style="color: red">{{
              errors[0]
            }}</span>
          </ValidationProvider>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <ValidationProvider
            rules="required"
            v-slot="{ errors, validate }"
            name="Choose a file"
          >
            <b-form-file
              v-on:change="readLogo"
              @change="validate"
              :state="Boolean(organization.logo)"
              placeholder="Choose a file..."
              drop-placeholder="Drop file here..."
            ></b-form-file>
            <span class="validate-error" style="color: red">{{
              errors[0]
            }}</span>
          </ValidationProvider>
        </b-col>
      </b-row>
      <b-row v-if="!isLightMode" class="mt-2">
        <b-col>
          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="location"
          >
            <GmapAutocomplete
              @place_changed="(e) => $emit('place_changed', e)"
              class="mt-1 location-search"
              :options="{
                fields: ['geometry', 'formatted_address', 'address_components'],
              }"
            ></GmapAutocomplete>
            <span class="validate-error" style="color: red">{{
              errors[0]
            }}</span>
          </ValidationProvider>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col md="6">
          <ValidationProvider
            :rules="{ regex: /^[a-zA-Z0-9 ]+$/, required: true }"
            v-slot="{ errors }"
            name="Registration No"
          >
            <c-input
              inputType="text"
              :inputId="`registrationNo`"
              lableText="Registration No *"
              v-model="organization.registrationNo"
              class="mt-0"
            /><span class="validate-error" style="color: red">{{
              errors[0]
            }}</span>
          </ValidationProvider>
        </b-col>
        <b-col md="6">
          <ValidationProvider
            :rules="{
              regex:
                /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[A-Z]{1}[0-9A-Z]{1}$/,
              required: true,
            }"
            v-slot="{ errors }"
            name="GST No"
          >
            <c-input
              inputType="text"
              :inputId="`gstNo`"
              lableText="GST No *"
              v-model="organization.gstNo"
              class="mt-0"
            />
            <span class="validate-error" style="color: red">{{
              errors[0]
            }}</span>
          </ValidationProvider>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col md="6">
          <ValidationProvider
            :rules="{ regex: /^\d{14}$/ }"
            v-slot="{ errors }"
            name="FSSAI No"
          >
            <c-input
              inputType="text"
              :inputId="`fssciNo`"
              lableText="FSSAI  No "
              v-model="organization.fssciNo"
              class="mt-0"
            />
            <span class="validate-error" style="color: red">{{
              errors[0]
            }}</span>
          </ValidationProvider>
        </b-col>
        <b-col md="6" v-if="!isLightMode">
          <eb-select
            v-model="organization.orgAccessLevel"
            :options="orgAccessOptions"
            @input="changeLevel"
            label="label"
            placeholder="Select org Access Level *"
          ></eb-select>
        </b-col>
        <b-col
          md="6"
          v-if="
            organization.orgAccessLevel &&
            organization.orgAccessLevel.value === 'Limited'
          "
        >
          <multiselect
            v-model="organization.orgAccessList"
            tag-placeholder="Add this as new org Access"
            placeholder="Select org Access List"
            label="userName"
            track-by="userName"
            :options="orgAccessListOptions"
            :multiple="true"
            :taggable="false"
            :open-direction="'top'"
          ></multiselect>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col md="6">
          <b-form-checkbox switch v-model="organization.isOwnCompany">
            <span class="mx-2">Own Company</span></b-form-checkbox
          >
        </b-col>
      </b-row>
      <slot name="footer-button" :data="organization"></slot>
    </ValidationObserver>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver, Rules } from "vee-validate";
import cInput from "@/components/FormElements/CustomInput";
import ebSelect from "@/components/FormElements/Select";
import Vue from "vue";

export default {
  name: "organizationStepper",
  props: ["officeData", "isLightMode"],
  watch: {
    officeData: function (officeData) {
      if (this.isLightMode) {
        if (this.$route.query.partner === "true") {
          this.organization.name = officeData?.office?.officeName;
        } else {
          this.organization.name = officeData.officeName;
        }
      }
    },
  },
  data() {
    return {
      organization: {
        name: "",
        logo: "",
        orgAccessLevel: " ",
        orgAccessList: null,
        registrationNo: "",
        gstNo: "",
        fssciNo: "",
        isOwnCompany: false,
      },
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    cInput,
    ebSelect,
  },
  computed: {
    orgAccessOptions() {
      return [
        {
          label: "Global",
          value: "Global",
        },
        {
          label: "Limited",
          value: "Limited",
        },
      ];
    },
    orgAccessListOptions() {
      let data = this.$store.getters["partner/GetPartnerList"];
      let tenantList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          if (obj.category === "OFFICE") {
            let arrayObj = {
              _id: obj._id,
              userName: obj.authentication.userName,
              email: obj.authentication.email,
              phone: obj.authentication.phone,
              password: "",
              ...obj,
            };
            tenantList.push(arrayObj);
          }
        });
        return tenantList;
      } else {
        return [];
      }
    },
  },
  methods: {
    isValid() {
      const isValid = this.$refs.observer.validate();
      this.$emit("isValid", isValid);
      return isValid;
    },
    readLogo(e) {
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = () => {
        this.uploadImage(reader.result);
      };
      reader.onerror = (err) => {};
    },
    // upload images to the S3 bucket
    async uploadImage(image) {
      let dataobj = {
        image: image,
        key: (
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
        ).toLowerCase(),
        isPublic: true,
        replaceExisting: true,
        basePath: "tenant",
      };
      this.showCustomToast();
      await this.$store
        .dispatch("inventory/uploadImageToStorage", dataobj)
        .then((res) => {
          if (res) {
            this.clearCustomToast();
            this.organization.logo = res.data.fileUrl;
          }
        })
        .catch((error) => {
          this.clearCustomToast();
          this.$toasted.error("Image not uploaded..please try again!");
        });
    },
    showCustomToast() {
      Vue.toasted.show("Uploading...", {
        type: "info",
        theme: "toasted-primary",
        singleton: true,
        duration: 1000000,
      });
    },
    clearCustomToast() {
      Vue.toasted.clear();
    },
    changeLevel(event) {
      if (event.value === "Global") {
        this.organization.orgAccessList = null;
      }
    },
  },
  mounted() {
    if (!this.$store.getters["partner/GetPartnerList"].length)
      this.$store.dispatch("partner/fetchPartnersList");
    if (this.isLightMode) {
      this.organization.orgAccessLevel = this.orgAccessOptions[0];
    }
  },
};
</script>
<style scoped>
.location-search {
  border-radius: 0rem;
  color: rgb(0, 0, 0);
  box-shadow: none !important;
  font-family: "Lato";
  height: 39px !important;
  border: 1px solid #dee2e6;
  padding-left: 10px;
  width: 90%;
  font-size: small;
}
[btn-color="primary"] {
  height: 41px;
  background-color: var(--primary);
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: "Lato";
  color: white;
  border: 0px;
  border-radius: 0px;
}

[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: "Lato";
  border-radius: 0px;
  height: 43px;
  width: 139px;
  background-color: var(--primary);
  color: white;
}
.custom-file-label {
  border-radius: 0px !important;
  border: 1px solid #dee2e6 !important;
  color: #dee2e6 !important;
}
</style>
